import axios from "axios";
import { url } from "../../../../env";
// Cache en memoria para persistir datos del formulario por persona.id
export const preloanFormMemory = new Map();



export const preloanFormValues = async (personaId) => {

    const endpoint = `${url}/preloan/${personaId}`;
    let response = await axios.get(endpoint, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}


  // Función helper para convertir fecha string DDMMYYYY a Date object
  export const parseDateString = (dateString) => {
    if (!dateString || typeof dateString !== 'string') return null;
    // Si ya es un objeto Date, retornarlo
    if (dateString instanceof Date) return dateString;
    // Si viene en formato DDMMYYYY (6 dígitos)
    if (dateString.length === 6 || dateString.length === 8) {
        const day = dateString.substring(0, 2);
        const month = dateString.substring(2, 4);
        const year = dateString.substring(4, 6);

        // Asumir años 2000+ para fechas recientes
        const fullYear = year > '50' ? `19${year}` : `20${year}`;

        try {
            return new Date(`${fullYear}-${month}-${day}`);
        } catch (e) {
            console.warn('Error parsing date:', dateString, e);
            return null;
        }
    }

    // Si viene en formato DD/MM/YYYY o similar
    if (dateString.includes('/')) {
        const parts = dateString.split('/');
        if (parts.length === 3) {
            const [day, month, year] = parts;
            return new Date(`${year}-${month}-${day}`);
        }
    }

    // Si viene en formato YYYY-MM-DD
    if (dateString.includes('-')) {
        try {
            return new Date(dateString);
        } catch (e) {
            console.warn('Error parsing date:', dateString, e);
            return null;
        }
    }

    return null;
};
